// extracted by mini-css-extract-plugin
module.exports = {"pdf":"PreviewpdfH5_pdf_3QV8n","iconContain":"PreviewpdfH5_iconContain_20Eef","iconClose":"PreviewpdfH5_iconClose_2hHjL"};